/* Sleepless Studio: Custom Studio hero slider, builder pre-pick links and product line pages.
   Runs alongside custom-studio.js (the quote builder) and never changes it.
   Pre-pick: ?add=tee ticks products by builder block ID, ?cat=drinkware shows one builder group. */
(function () {
  'use strict';
  if (window.__csPages) return;
  window.__csPages = true;

  function list(str) { return String(str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function slug(str) { return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* ---------- Builder pre-pick ---------- */
  function preselect(add, cat, scroll) {
    var root = document.querySelector('[data-cs-builder]');
    var b = root && root.__csBuilder;
    if (!b) return false;
    var s = b.s;
    list(add).forEach(function (id) {
      var p = b.byId(id);
      if (p && !s.sel[id]) { s.sel[id] = true; if (!s.cfg[id]) s.cfg[id] = b.defCfg(p); }
    });
    var want = slug(cat), match = null;
    if (want) b.products.forEach(function (p) { if (!match && slug(p.category) === want) match = p; });
    s.cat = match ? match.category : 'all';
    s.q = '';
    var search = root.querySelector('[data-cs-search]');
    if (search) search.value = '';
    s.step = 1;
    b.renderAll();
    if (scroll) root.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-cs-add], a[data-cs-cat]');
    if (!a) return;
    if (preselect(a.getAttribute('data-cs-add'), a.getAttribute('data-cs-cat'), true)) e.preventDefault();
  });

  /* ---------- Hero slider ---------- */
  function Hero(root) {
    var self = this;
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.cs-hero__slide'));
    this.pauseBtn = root.querySelector('[data-cs-hero-pause]');
    this.cur = 0;
    this.secs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    this.held = false;
    this.auto = this.secs > 0 && !reduced() && !(window.Shopify && window.Shopify.designMode);
    root.style.setProperty('--cs-hero-secs', (this.secs || 7) + 's');
    this.tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { self.stop(); self.show(i); });
    });
    var tablist = root.querySelector('[role="tablist"]');
    if (tablist) tablist.addEventListener('keydown', function (e) {
      var k = e.key, n = self.tabs.length, to = null;
      if (k === 'ArrowRight') to = (self.cur + 1) % n;
      else if (k === 'ArrowLeft') to = (self.cur - 1 + n) % n;
      else if (k === 'Home') to = 0;
      else if (k === 'End') to = n - 1;
      if (to === null) return;
      e.preventDefault(); self.stop(); self.show(to); self.tabs[to].focus();
    });
    if (this.pauseBtn) this.pauseBtn.addEventListener('click', function () { self.stop(); });
    ['mouseenter', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { self.held = true; root.classList.add('is-held'); }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, function () { self.held = false; root.classList.remove('is-held'); }); });
    if (this.auto) { root.classList.add('is-playing'); this.arm(); } else this.stop();
  }
  Hero.prototype.show = function (i) {
    this.cur = i;
    this.tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
    this.slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    if (this.auto) this.arm();
  };
  Hero.prototype.arm = function () {
    var self = this, bar = this.tabs[this.cur] && this.tabs[this.cur].querySelector('i');
    if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    clearInterval(this.timer);
    var left = this.secs * 1000;
    this.timer = setInterval(function () {
      if (self.held || document.hidden) return;
      left -= 250;
      if (left <= 0) self.show((self.cur + 1) % self.tabs.length);
    }, 250);
  };
  Hero.prototype.stop = function () {
    this.auto = false;
    clearInterval(this.timer);
    this.root.classList.remove('is-playing');
    if (this.pauseBtn) this.pauseBtn.hidden = true;
  };
  Hero.prototype.select = function (blockId) {
    var self = this;
    this.slides.forEach(function (s, k) { if (s.getAttribute('data-cs-block') === blockId) { self.stop(); self.show(k); } });
  };

  /* ---------- Product line pages: gallery and tee print sizes ---------- */
  function ProductLine(root) {
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-cs-thumb]');
      if (th) {
        var i = th.getAttribute('data-cs-thumb');
        root.querySelectorAll('[data-cs-thumb]').forEach(function (b) { var on = b === th; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-cs-media]').forEach(function (m) {
          var on = m.getAttribute('data-cs-media') === i;
          m.classList.toggle('is-on', on);
          var v = m.querySelector('video');
          if (v) { if (on) { var p = v.play(); if (p && p['catch']) p['catch'](function () {}); } else v.pause(); }
        });
        return;
      }
      var z = e.target.closest('button[data-zone]');
      if (z) {
        var scale = z.closest('[data-cs-scale]'), zone = z.getAttribute('data-zone');
        scale.querySelectorAll('button[data-zone]').forEach(function (b) { var on = b === z; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        scale.querySelectorAll('rect[data-zone]').forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-zone') === zone); });
        scale.querySelector('[data-cs-measure]').textContent = z.getAttribute('data-measure');
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cs-hero]').forEach(function (root) {
      if (!root.__csHero) root.__csHero = new Hero(root);
    });
    (scope || document).querySelectorAll('[data-cs-pl]').forEach(function (root) {
      if (!root.__csPl) root.__csPl = new ProductLine(root);
    });
  }
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    init();
    var params = new URLSearchParams(window.location.search);
    if (params.get('add') || params.get('cat')) preselect(params.get('add'), params.get('cat'), false);
  }
  /* This file can run before custom-studio.js (both deferred), so wait until every deferred script has run and the builder exists. */
  if (document.readyState === 'complete') boot();
  else { document.addEventListener('DOMContentLoaded', boot); window.addEventListener('load', boot); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-cs-hero]');
    if (hero && hero.__csHero) hero.__csHero.select(e.detail.blockId);
  });
})();
